import { api } from ".";

export const getMonthlyReport = async (params: Record<string, any>) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );

    return await api.get(`/report/monthly-report`, { params: filteredParams });
  } catch (error) {
    return error;
  }
};

export const getMonthlyReportExcel = async (params: Record<string, any>) => {
  try {
    const res = await api.get(`/report/monthly-report/export-excel`, {
      headers: { "Content-Type": "blob" },
      params: Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== undefined)
      ),
      responseType: "arraybuffer",
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getDailyActivityReport = async (params: Record<string, any>) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );

    return await api.get(`/report/daily-activity-report`, {
      params: filteredParams,
    });
  } catch (error) {
    return error;
  }
};

export const getDailyActivityReportExcel = async (
  params: Record<string, any>
) => {
  try {
    const res = await api.get(`/report/daily-activity-report/export-excel`, {
      headers: { "Content-Type": "blob" },
      params: Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== undefined)
      ),
      responseType: "arraybuffer",
    });
    return res;
  } catch (error) {
    return error;
  }
};

/*
 * Filtre listeleri buradan KALDIRILDI (plan 2.22).
 *
 * `/report/monthly-report/departments`, `/positions` ve
 * `/daily-activity-report/terminals` uçları backend'de hiç var olmamıştı.
 * Aynı veriyi veren canlı uçlar zaten mevcut ve `{value,label}` döndürüyor:
 *
 *   departman → departmentApi.getDepartmentSelectData()
 *   etiket    → tagApi.getTagSelectData()        (eski "pozisyon"un yerini aldı)
 *   terminal  → terminalApi.getTerminalSelectData()
 *
 * Bunlar id gönderdiği için filtreler arka uçta `departmentIds` / `tagIds` ile
 * doğrudan eşleşiyor.
 */

/*
 * EKSİK ÇIKIŞ DÜZELTMESİ (plan 2.49-B).
 *
 * ⚠ `/report` altında DEĞİL, `/workday-correction` altında: rapor uçları
 * salt okur, bu ise `hr/` altındaki tek puantaj YAZMA yolu. Ayrı tutulması
 * bilinçli — okuma ile yazmanın aynı önekte durması, ileride yetki kapısı
 * konulması gerektiğinde ayrımı görünmez kılardı.
 */
export const upsertWorkdayCorrection = async (body: {
  employeeId: string;
  workday: string;
  exitAt: string;
  note: string;
}) => api.post(`/workday-correction`, body);

export const removeWorkdayCorrection = async (body: {
  employeeId: string;
  workday: string;
}) => api.delete(`/workday-correction`, { data: body });

/*
 * ÇALIŞAN BİLDİRİMLERİ — İK'nın iş kuyruğu (plan 2.50).
 *
 * ⚠ `approve` bildirimi 2.49-B düzeltmesine çevirir. Otomatik değil: bu uç
 * ancak İK bir düğmeye bastığında çağrılıyor. Bildirim tek başına puantajda
 * hiçbir şey değiştirmez — çalışan kendi saatini kendi yazmış olmamalı.
 */
export const getCorrectionRequests = async (status?: string) =>
  api.get(`/workday-correction/requests`, {
    params: status ? {status} : undefined,
  });

export const approveCorrectionRequest = async (requestId: string) =>
  api.post(`/workday-correction/requests/approve`, {requestId});

export const rejectCorrectionRequest = async (requestId: string, note?: string) =>
  api.post(`/workday-correction/requests/reject`, {
    requestId,
    ...(note ? {note} : {}),
  });
